import { cn } from '@wwe-portal/ui/lib/lib';
import Image from 'next/image';

interface TagTeam {
  id: string | number;
  type: string;
  image: string;
  description: string;
}
interface TagTeamLinksProps {
  tagTeam: TagTeam[];
  className?: string;
}

export const TagTeamLinks = ({ tagTeam, className }: TagTeamLinksProps) => {
  return (
    <div className={cn('drop-shadow-card bg-[#191D3CB2] pb-5', className)}>
      <div className="grid grid-cols-12 gap-4 px-4 py-3 text-xs font-semibold uppercase italic text-[#F5A200]">
        <div className="drop-shadow-shade-strong col-span-5">Links</div>
        <div className="drop-shadow-shade-strong col-span-7">Buffs</div>
      </div>

      {tagTeam.map((tagTeam) => (
        <div
          className="drop-shadow-base mb-2 grid min-h-16 grid-cols-12 gap-4 rounded-md bg-[#212541] px-4 text-xs font-semibold italic text-white"
          key={tagTeam.id}
        >
          <div className="col-span-5 flex items-center gap-2">
            <Image
              className="h-10 w-10 rounded-full"
              src={tagTeam.image}
              alt={tagTeam.type}
              width={40}
              height={40}
            />
            <span className="drop-shadow-shade-strong">{tagTeam.type}</span>
          </div>
          <div className="col-span-7 flex items-center">
            <span className="drop-shadow-shade-strong">
              {tagTeam.description}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};
